export const REVIEW_CONSTS = {
    GET_REVIEWS: "GET_REVIEWS",
    SET_REVIEW_AS_SEEN: "SET_REVIEW_AS_SEEN",
    DELETE_REVIEW: "DELETE_REVIEW",
    GET_NOT_SEEN_REVIEWS_COUNT: "GET_NOT_SEEN_REVIEWS_COUNT",
    SET_ALL_REVIEWS_AS_SEEN: "SET_ALL_REVIEWS_AS_SEEN",
};
